import styled from 'styled-components'
import { transparentize } from 'polished'
import { sizes } from '../../util'

export const GroupHeader = styled.span`
  display: flex;
  font-size: ${({ size }) => (size === 'big' ? '2.75rem' : '0.75rem')};
  font-weight: ${({ size }) => (size === 'big' ? 400 : 600)};
  text-transform: ${({ size }) => (size === 'big' ? 'none' : 'uppercase')};
  letter-spacing: 0.03em;
  line-height: 1.3;

  padding: 1.5rem 0;
  /* border-top: 1px solid rgba(0, 0, 0, 0.5); */
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  /* letter-spacing: 0.02em; */
  margin: 0;
  padding-right: 2rem;
  &.name {
    flex: 3;
  }
  &.program {
    flex: 4;
  }
  &.show {
    flex: 4;
  }
  &.social {
    flex: none;
    width: 9rem;
    display: flex;
    padding-right: 0;
  }
  @media (min-width: ${sizes.medium}) {
  }
`

export const GroupBody = styled.li`
  display: flex;
  flex-wrap: wrap;
  padding: 1.25rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  flex-direction: column;
  position: relative;
  z-index: 2;
  /* &:last-child {
    border-bottom: none;
  } */
  &:hover {
    color: ${props => props.theme.colorText};
    background: rgba(255, 255, 255, 0.9);
    opacity: 1;
    z-index: 4;
    /* transform: scale(1.01); */
    + img {
      opacity: 1;
    }
  }
  @media (min-width: ${sizes.medium}) {
    flex-direction: row;
    align-items: center;
  }
  @media (max-width: ${sizes.medium}) {
    .name,
    .program,
    .show {
      margin-bottom: 0.5rem;
    }
    .name {
      font-size: 1.3rem;
    }
    .program {
      font-size: 1.1rem;
    }
    .show {
      font-size: 1.1rem;
    }
  }
`

export const Cell = styled.span`
  flex: 3;
  min-width: 0;
  min-height: 0;
  margin-right: 2rem;
  &.name {
    flex: 3;
  }
  &.program {
    flex: 4;
  }
  &.show {
    flex: 4;
  }
  &.social {
    margin-right: 0;
    a {
      /* color: black; */
      background: none;
    }
    @media (min-width: ${sizes.medium}) {
      flex: none;
      width: 9rem;
      justify-content: flex-end;
      display: flex;
      a {
        margin-left: 0.5rem;
      }
    }
  }
  a {
    color: ${props => props.theme.colorText};
    border-bottom: none;
    background-image: linear-gradient(
      to right,
      ${props => props.theme.colorText} 0%,
      ${props => props.theme.colorText} 100%
    );
    background-repeat: repeat-x;
    background-position: 0 95%;
    background-size: 100% 1px;

    &:hover {
      opacity: 0.5;
    }
  }
`

export const CellImage = styled.img`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  max-height: 50rem;
  max-width: 50rem;
  opacity: 0;
  pointer-events: none;
`

export const CustomSelect = styled.div`
  &.customSelect {
    select {
      padding: 0.9rem 0.5rem;
      color: ${props => props.theme.colorText};

      &:focus {
        background: ${props => transparentize(0.95, props.theme.colorText)};
        outline-color: #fff
      }
      @media (max-width: ${sizes.medium}) {
        border-top: 1px solid ${props => props.theme.colorText};
        border-right: 1px solid ${props => props.theme.colorText};
        padding: 1rem .5rem;
        font-size: 1.25rem;
      }
    }
    &:after {
      top: 50%;
      transform: translateY(-50%);
    }
    @media (max-width: ${sizes.medium}) {
      &::after {
        display: none;
      }
    }
    &:hover {
      select {
        color: ${props => props.theme.colorText};
        &:focus {
          background: ${props => transparentize(0.95, props.theme.colorText)};
          outline-color: #fff};
          outline: none;
        }
      &::after {
        color: ${props => props.theme.colorText};
      }
    }
  }
}
`

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  width: 100%;

  label {
    border-right: 1px solid ${props => props.theme.colorText};
  }

  ${({ isSticky }) =>
    isSticky &&
    `
    border-left: 1px solid;
    border-bottom: 1px solid;
    @media (max-width: ${sizes.extraLarge}) {
      width: 75%;
    }
    @media (max-width: ${sizes.large}) {
      width: 50%;
    }
    @media (max-width: ${sizes.medium}) {
      border-right: none;
    }
  `}

  @media (min-width: ${sizes.medium}) {
    flex-direction: row;
  }
`

export const Box = styled.div`
  width: 100%;
  background: white;
  max-width: ${({ width }) => (width === 'full' ? 'auto' : '30rem')};
  color: ${({ theme }) => theme.colorText};
  align-self: ${({ align }) => align};
  ${({ shadow }) => shadow && 'box-shadow: 0 0 1.5rem rgba(0,0,0,0.15);'}

  .student-list {
    margin: 0 4rem;
  }
  .student.header {
    border-bottom: 0;
    background: white !important;
    z-index: 200;
    padding: 0;
    span {
      border-color: ${({ theme }) => theme.colorText};
      padding: 1rem 0;
    }
  }

  @media (max-width: ${sizes.medium}) {
    .student-list {
      margin: 0 2rem;
    }
  }
`

export const Wrapper = styled.div`
  max-width: ${({ width }) => (width === 'full' ? 'auto' : '100rem')};
  /* margin: ${({ width }) => (width === 'full' ? '0 auto' : '1rem')}; */
  margin: 0 auto;
  position: relative;
  z-index: ${({ z }) => z || 1};
  display: flex;
  flex-direction: column;
  background: ${({ bg }) => bg || 'transparent'};
  @media (min-width: ${sizes.medium}) {
    padding: ${({ width }) => (width === 'full' ? '0' : '0 4rem')};
  }
`

export const Top = styled.div`
  font-size: ${({ size }) => (size === 'big' ? '2.75rem' : '0.75rem')};
  font-weight: ${({ size }) => (size === 'big' ? 400 : 600)};
  text-transform: ${({ size }) => (size === 'big' ? 'none' : 'uppercase')};
  letter-spacing: 0.03em;
  line-height: 1.3;
  padding: ${({ size }) => (size === 'big' ? '2rem 4rem 1rem' : '1rem 4rem')};
  border-bottom: 1px solid;
  @media (max-width: ${sizes.medium}) {
    font-size: ${({ size }) => (size === 'big' ? '2rem' : '0.75rem')};
    padding: ${({ size }) => (size === 'big' ? '2rem 2rem 1rem' : '1rem 2rem')};
  }
`

export const Tag = styled.p`
  font-size: 4rem;
  line-height: 1.1;
  padding: 2rem 4rem;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: space-between;
  button {
    -webkit-appearance: none;
    -moz-appearence: none;
    border: 0;
    background: ${props => props.theme.colorText};
    text-transform: uppercase;
    color: white;
    font-size: 1.5rem;
    padding: 0.25rem 1rem;
    &:after {
      margin-left: 0.333em;
      content: '→';
    }
    &:hover,
    &:focus {
      opacity: 0.7;
      cursor: pointer;
    }
  }
  @media (max-width: ${sizes.medium}) {
    align-items: flex-start;
    flex-direction: column;
    font-size: 3rem;
    padding: 2rem;
    button {
      font-size: 1rem;
    }
  }
`
